export default {

  Title: 'Group Ελαστικών',

  Table: {
    Headers: {
      Id       : '#',
      Name     : 'ΤΙΤΛΟΣ',
      Code     : 'ΚΩΔΙΚΟΣ',
      Active   : 'ΕΝΕΡΓΟ',
      CreatedAt: 'ΕΓΓΡΑΦΗ',
      Actions  : ''
    }
  },

  Form: {
    Title : 'Group Ελαστικών',
    Fields: {
      Name  : { Label: 'Τίτλος', Hint: '' },
      Code  : { Label: 'Κωδικός', Hint: '' },
      Active: {
        Label: 'Ενεργό',
        Hint : ''
      }
    }
  },

  Button: {
    Groups  : 'Groups',
    New     : 'Νέο Group',
    All     : 'ΟΛΑ',
    Active  : 'ΕΝΕΡΓΑ',
    Inactive: 'ΑΝΕΝΕΡΓΑ'
  }

}
